import type { SVGProps } from 'react'
const IconPinBoldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.25 10.339a.75.75 0 0 1-1.5 0V7.796a.75.75 0 0 1 1.5 0zm5.146 2.401-.94-1.175a2.6 2.6 0 0 1-.564-1.589l-.023-2.607c-.004-.482.29-.852.534-1.077.526-.48.788-1.163.721-1.875-.108-1.145-1.142-2.043-2.353-2.043H9.23c-1.21 0-2.245.898-2.353 2.043a2.23 2.23 0 0 0 .72 1.874c.246.226.54.596.535 1.078l-.023 2.609a2.58 2.58 0 0 1-.564 1.586l-.94 1.176a2.42 2.42 0 0 0-.292 2.578 2.42 2.42 0 0 0 2.197 1.381h3.241v4.177a.75.75 0 0 0 1.5 0v-4.177h3.241c.946 0 1.788-.529 2.197-1.381a2.42 2.42 0 0 0-.292-2.578"
      clipRule="evenodd"
    />
  </svg>
)
export default IconPinBoldIcon
